import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { ErrorDetails } from "@/routes/ErrorBoundary";

class LazoAuthService {
  private path: string;

  constructor(path: string) {
    this.path = path;
  }

  logError(error: ErrorDetails): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/`, error);
  }
}

export default new LazoAuthService("/api/log-error");
